/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Tri10IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Tri10Icon(props: Tri10IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 126 126"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={"m39.836 23 69.117 40.042-68.998 39.836-.12-79.879z"}
        opacity={".15"}
      ></path>

      <path
        fill={"currentColor"}
        d={"m108.953 63.042-68.998 39.836-.072-48.406 26.94-15.553v-.285z"}
        opacity={".15"}
      ></path>

      <path
        fill={"currentColor"}
        d={
          "m108.953 63.042-68.998 39.835-.037-24.642L87.42 50.81v-.244l21.534 12.475z"
        }
        opacity={".15"}
      ></path>
    </svg>
  );
}

export default Tri10Icon;
/* prettier-ignore-end */
